import { ElevatedSystemWallet } from './UserSettingsContext';

export const USER_SETTINGS_KEY: string = 'user-settings';
export const ELEVATED_SYSTEM_WALLET_KEY = 'elevatedSystemWallet';

export interface UserSettings {
    [ELEVATED_SYSTEM_WALLET_KEY]: ElevatedSystemWallet;
}
